<template>
  <div class="container">
    <div class="content">
      <div class="header">
        <van-image
          style="width: 100%;"
          :src="picUrl+'zq_pro/dzk_cdSkinPackage1/lkbg.png'"
          fit="contain"
        />
      </div>
      <div class="main">
        <div class="block-height"></div>
        <div class="tab-wrap">
          <div
            class="tab"
            :class="{ active: index == tabIndex }"
            v-for="(item, index) in tabData"
            :key="index"
            @click="tabChange(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="tab-content">
          <div v-if="tabIndex == 1">
            <div class="form-item">
              <input
                class="input"
                placeholder-class="placeholderClass"
                name="input"
                placeholder="请输入手机号码"
                v-model="phone"
                @blur="blur"
              />
            </div>
            <div class="form-item message">
              <input
                class="input"
                placeholder-class="placeholderClass"
                name="input"
                placeholder="请输入验证码"
                v-model="code"
                @blur="blur"
              />
              <div class="button" @click="sendMsg('FREE_CARD_VERIFY')">{{ msgSendTxt }}</div>
            </div>
            <div class="btn-v">
              <button class="button" @click="freeBindCard">确定</button>
            </div>
            <div class="desc">
              <span v-if="mode == 2">*激活成功后，请使用该激活手机号打开微信 公众号“畅游权益卡”，可立即使用</span>
              <span v-else>*激活成功后，请使用该激活手机号登录微信 小程序“中青自由行”，可立即使用</span>
            </div>
          </div>
          <div v-if="tabIndex == 0">
            <div class="form-item">
              <input
                class="input"
                placeholder-class="placeholderClass"
                name="input"
                placeholder="请输入手机号码"
                v-model="phone"
                @blur="blur"
              />
            </div>
            <div class="form-item message">
              <input
                class="input"
                placeholder-class="placeholderClass"
                name="input"
                placeholder="请输入验证码"
                v-model="code"
                @blur="blur"
              />
              <div class="button" @click="sendMsg('GIVE_CARD_VERIFY')">{{ msgSendTxt }}</div>
            </div>
            <div class="splitLine"></div>
            <div class="quantitySelection">
              <div class="selectQuant">选择数量：</div>
              <div 
                class="quant" 
                :class="{ active: index == quantIndex }"
                v-for="(item, index) in 5"
                :key="index"
                @click="quantChange(index, item)" v-text="item">
              </div>
            </div>
            <div class="btn-v">
              <button class="button" @click="verifyCodeCreateCardAndSendSMS">确定</button>
            </div>
            <div class="desc2">
              <span v-if="mode == 2">*我们将通过手机短信把卡号发送给您， ，请使用该激活手机号打开微信 公众号“畅游权益卡”进行激活使用</span>
              <span v-else>*我们将通过手机短信把卡号发送给您， 请使用微信登录“中青自由行”小程序进行激活使用</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import md5 from "js-md5"
import Cookies from "js-cookie"
import { checkUserAgent } from '@/utils/checkUserAgent'
import { commonSendSms, freeBindCard, verifyCodeCreateCardAndSendSMS } from '@/api/index.js'
import { Toast, Dialog } from "vant"


export default {
  name: "CardActive",
  components: {},
  mixins: [checkUserAgent],
  data() {
    return {
      picUrl: "",
      tabIndex: 0,
      quantIndex: 0,
      price: 0,
      orderId: "",
      phone: "",
      code: "",
      msgSendStatus: true,
      msgSendTxt: "获取验证码",
      channelId: "",
      productId: "",
      userAgent: '',
      number: 1,
      mode: 1,
      activateFlag: ''
    }
  },
  created() {
    this.picUrlQuery();
    this.init();
    this.mode = Cookies.get('mode')
    this.activateFlag = Cookies.get('activateFlag')
  },
  computed: {
    tabData() {
      return this.activateFlag == 0 ? ["在线领取", "在线激活"] : ["在线领取"]
    }
  },
  methods: {
    // 圖片前綴
    picUrlQuery() {
      const that = this;
      request({
        url: "/tour-product/imge/getUrl",
        method: "post",
      })
        .then(function (res) {
          if (res.data.code != "200") {
            throw res.data.msg;
          }
          if (res.data.code == "200") {
            that.picUrl = res.data.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    init() {
      this.channelId = Cookies.get("cykskid") // 代理商ID
      this.productId = Cookies.get("productId") // 卡片ID
    },
    blur() {
      document.querySelector('body').setAttribute('style', 'height:'+document.documentElement.clientHeight+'px;')
      window.scrollTo(0,0)
    },
    tabChange(index) {
      this.tabIndex = index;
    },
    quantChange(index, number) {
      this.quantIndex = index;
      this.number = number;
    },
    // 发送短信
    sendMsg(tag) {
      const that = this;
      if (this.phone.length < 1) {
        this.$toast("手机号为空");
        return false;
      } else {
        const reg = /^1[3-9]\d{9}$/g;
        const result = reg.test(this.phone);
        if (!result) {
          this.$toast("请输入正确格式的手机号");
          return;
        }
      }
      if (!this.msgSendStatus) {
        return;
      }
      const appId = 1;
      const key = 1112;
      const sortstr = "appId=" + appId + "&phone=" + this.phone + "" + key;

      const sign = md5(sortstr).toUpperCase();

      const data = {
        sign: sign,
        appId: appId,
        phone: this.phone,
        productType: Cookies.get("productType")||0,
        tag
      };
      commonSendSms(data).then(res=>{
        console.log(res)
        if (res.data.code !== 200) {
            throw res.data.msg;
          }
          if (res.data.code === 200) {
            that.$toast(res.data.msg);
            let time = 60;
            (that.msgSendStatus = false), (that.msgSendTxt = time + "秒再试");
            let timer = setInterval(function () {
              if (time <= 0) {
                (that.msgSendStatus = true), (that.msgSendTxt = "获取验证码");
                clearInterval(timer);
                return false;
              }
              that.msgSendTxt = time + "秒再试";
              that.sendStatus = false;
              time--;
            }, 1000);
          }
      }).catch((err) => {
        that.$toast(err);
      });
    },
    // 在线激活
    freeBindCard() {
      let that = this
      if (this.activateFlag != 0) return this.$toast('链接或二维码异常，暂不支持在线激活业务')
      if (that.phone.length < 1) {
        that.$toast("手机号为空");
        return false;
      } else {
        const reg = /^1[3-9]\d{9}$/g;
        const result = reg.test(that.phone);
        if (!result) {
          that.$toast("请输入正确格式的手机号");
          return;
        }
      }
      if (that.code.length < 1) {
        that.$toast("验证码为空");
        return false;
      }
      let data = {
        channelBusinessId: that.channelId,
        phone: that.phone,
        productId: that.productId,
        tag: 'FREE_CARD_VERIFY',
        verifyCode: that.code
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      freeBindCard(data).then(res=>{
        Toast.clear();
        if (res.data.code !== 200) {
            throw res.data.msg;
          }
          if (res.data.code === 200) {
            if (this.mode == 2) {
              Dialog.confirm({
                title: "",
                message: "您的会员卡已成功激活，请前往微信公众号使用",
                showCancelButton: true,
                confirmButtonText: "现在前往",
                confirmButtonColor: "#00C5A5",
                cancelButtonText: "我知道了",
                cancelButtonColor: "#848484"
              })
                .then(() => {
                  location.href = 'https://shengka-wap-pro.cytsszt.com/#/pagesB/bookScenic/index?isHome=1'
                })
                .catch(() => {})
            } else {
              Dialog.confirm({
                title: "",
                message: "您的会员卡已成功激活，请前往小程序使用",
                showCancelButton: true,
                confirmButtonText: "现在前往",
                confirmButtonColor: "#00C5A5",
                cancelButtonText: "我知道了",
                cancelButtonColor: "#848484"
              })
                .then(() => {
                  location.href = 'weixin://dl/business/?t=5o4T2fN28Sa'
                })
                .catch(() => {})
            }
            
          }
      }).catch((err) => {
        Toast.clear();
        that.$toast(err);
      });
    },
    // 在线领取
    verifyCodeCreateCardAndSendSMS() {
      let that = this
      const activateFlagList = [0, 1, '0', '1']
      if (!activateFlagList.includes(this.activateFlag)) return this.$toast("链接或二维码异常，暂不支持在线领取业务")
      if (that.phone.length < 1) {
        return that.$toast("手机号为空")
      } else {
        const reg = /^1[3-9]\d{9}$/g
        const result = reg.test(that.phone)
        if (!result) {
          return that.$toast("请输入正确格式的手机号")
        }
      }
      if (that.code.length < 1) {
        return that.$toast("验证码为空")
      }
      let data = {
        agentId: that.channelId,
        phone: that.phone,
        num: that.number,
        productId: that.productId,
        tag: 'GIVE_CARD_VERIFY',
        verifyCode: that.code,
        model: this.mode == 2 ? 2 : 1,
        activateFlag: this.activateFlag
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      verifyCodeCreateCardAndSendSMS(data).then(res=>{
        Toast.clear();
        if (res.data.code !== 200) {
            throw res.data.msg;
          }
          if (res.data.code === 200) {
            if (this.mode == 2) {
              Dialog.confirm({
                title: "",
                message: "会员卡已通过短信方式发送给您，请前往公众号使用",
                showCancelButton: true,
                confirmButtonText: "现在前往",
                confirmButtonColor: "#00C5A5",
                cancelButtonText: "我知道了",
                cancelButtonColor: "#848484"
              })
                .then(() => {
                  location.href = 'https://shengka-wap-pro.cytsszt.com/#/pagesB/activation/index?isHome=1'
                })
                .catch(() => {})
            } else {
              Dialog.confirm({
                title: "",
                message: "会员卡已通过短信方式发送给您，请前往小程序使用",
                showCancelButton: true,
                confirmButtonText: "现在前往",
                confirmButtonColor: "#00C5A5",
                cancelButtonText: "我知道了",
                cancelButtonColor: "#848484"
              })
                .then(() => {
                  location.href = 'weixin://dl/business/?t=5o4T2fN28Sa'
                })
                .catch(() => {})
            }
          }
      }).catch((err) => {
        Toast.clear();
        that.$toast(err);
      });
    }
  },
};
</script>

<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0px;
  width: 100%;
  height: 100%;
  background: #F6F6F6;
  z-index: 10;
  overflow: hidden;
}
.content .header{
  z-index: 50;
  text-align: center;
}
.content .main{
  width: 702px;
  background: #FFFFFF;
  border-radius: 32px;
  margin: 0px auto 0 auto;
  z-index: 100;
  position: relative;
  top: -320px;
}
.block-height{
  height: 36px;
}
.tab-wrap {
  display: flex;
  margin: 0px auto 0 auto;
  border-radius: 40px;
  width: 400px;
  height: 80px;
  font-size: 32px;
  font-weight: bold;
  line-height: 80px;
  text-align: center;
  background: #f7f7f7;
}
.tab-wrap .tab {
  width: 100%;
  height: 100%;
  font-size: 32px;
  font-weight: bold;
  color: #00C5A5;
}
.tab-wrap .tab.active {
  border-radius: 40px;
  background: #00C5A5;
  color: #FFFFFF;
}
.tab-content {
  padding: 36px 40px 50px 40px;
  width: calc(100% - 80px);
  text-align: center;
}
.tab-content .form-item {
  margin-bottom: 40px;
  font-size: 32px;
}
.tab-content .form-item.message {
  display: flex;
  justify-content: space-between;
}
.tab-content .form-item .input {
  border-radius: 40px;
  padding: 0 40px;
  width: calc(100% - 80px);
  height: 80px;
  background: #F6F6F6;
}
.tab-content .form-item.message .input {
  width: calc(100% - 300px);
}
.tab-content .form-item .placeholderClass {
  font-size: 32px;
  line-height: 80px;
  color: #999;
}
.tab-content .form-item.message .button {
  width: 200px;
  height: 80px;
  font-size: 32px;
  line-height: 80px;
  text-align: center;
  color: #00C5A5;
}

.tab-content .btn-v .button {
  border-radius: 40px;
  width: 100%;
  height: 80px;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  background: #00C5A5;
}
.tab-content .splitLine{
  width: 600px;
  height: 0px;
  border: 2px solid #EEEEEE;
  margin: 32px auto 34px auto;
}
.tab-content .quantitySelection{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
}
.tab-content .quantitySelection .selectQuant{
  height: 44px;
  font-size: 32px;
  font-weight: bold;
  color: #333333;
  line-height: 44px;
  margin-right: 14px;
}
.tab-content .quantitySelection .quant{
  width: 80px;
  height: 56px;
  background: #F6F6F6;
  border-radius: 28px;
  text-align: center;
  font-size: 32px;
  color: #666666;
  line-height: 56px;
  margin-left: 8px;
}
.tab-content .quantitySelection .quant.active{
  color: #FFFFFF;
  background: #00C5A5;
}
.tab-content .desc {
  width: 470px;
  margin: 16px auto 0 auto;
  font-size: 24px;
  color: #8D8D8D;
  line-height: 34px;
  text-align: center;
}
.tab-content .desc2{
  width: 530px;
  margin: 16px auto 0 auto;
  font-size: 24px;
  color: #8D8D8D;
  line-height: 34px;
  text-align: center;
}
</style>
